import { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import PageTitle from '../components/UtilityHelpers/PageTitle';

import { useArchiveList } from '../hooks/Request/useArchiveList';
import { useUtils } from '../hooks/useUtils';

import RequestStatCard from "../components/Cards/RequestStatCard";
import ArchivedLatestRequestCard from "../components/Cards/Archived/ArchivedLatestRequestCard";
import ArchivedNewRequestCard from '../components/Cards/Archived/ArchivedNewRequestCard';
import ArchivedApprovedRequestCard from '../components/Cards/Archived/ArchivedApprovedRequestCard';
import ArchivedWhiteListedRequestCard from '../components/Cards/Archived/ArchivedWhiteListedRequestCard';
import ArchivedOrderedRequestCard from '../components/Cards/Archived/ArchivedOrderedRequestCard';
import ArchivedPurchasedRequestCard from '../components/Cards/Archived/ArchivedPurchasedRequestCard';
import ArchivedDeliveredRequestCard from '../components/Cards/Archived/ArchivedDeliveredRequestCard';
import ArchivedDeclinedRequestCard from '../components/Cards/Archived/ArchivedDeclinedRequestCard';

const ArchivedListPage = () => {
const [showList, setShowList] = useState(1);

    const listToShow = () => {
        if (showList == 1) {
            return <ArchivedLatestRequestCard />
        }

        if (showList == 2) {
            return <ArchivedNewRequestCard />
        }

        if (showList == 3) {
            return <ArchivedApprovedRequestCard />
        }

        if (showList == 4) {
            return <ArchivedWhiteListedRequestCard />
        }

        if (showList == 5) {
            return <ArchivedOrderedRequestCard />
        }

        if (showList == 6) {
            return <ArchivedPurchasedRequestCard />
        }

        if (showList == 7) {
            return <ArchivedDeliveredRequestCard />
        }

        if (showList == 8) {
            return <ArchivedDeclinedRequestCard />
        }
    }
    
    const requestList = useArchiveList();
    const helperUtils = useUtils();

    useEffect(() => {
        // budgetDetails?.fetchBudgetDetails();
        requestList?.fetchList();
    }, []);    
    return (
        <>
            <PageTitle title="OPS | Archived List Page" />
            <MainLayout>
                
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-3 2xl:gap-7.5 mb-5">
                    <h5 className="text-xl font-semibold text-black dark:text-white">
                        Archived List Page (Requests from last year)
                    </h5>                    
                </div>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-4 md:gap-6 xl:grid-cols-6 2xl:gap-2.5 mb-5">
                    <div onClick={() => setShowList(1)} className="cursor-pointer">
                        <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.allRequestListCount ? requestList?.allRequestListCount.toString() : "0"} label={"All"} bgColour="bg-slate-500"/>
                    </div>
                    <div onClick={() => setShowList(2)}  className="cursor-pointer">
                        <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.newRequestListCount ? requestList?.newRequestListCount.toString() : "0"} label={"New"} bgColour="bg-request-status-new"/>
                    </div>
                    <div onClick={() => setShowList(3)}  className="cursor-pointer">
                        <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.approvedRequestListCount ? requestList?.approvedRequestListCount.toString() : "0"} label={"Approved"} bgColour="bg-request-status-approved"/>
                    </div>
                    <div onClick={() => setShowList(4)}  className="cursor-pointer">
                        <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.waitListedListCount ? requestList?.waitListedListCount.toString() : "0"} label={"Waitlisted"} bgColour="bg-request-status-waitlisted"/>
                    </div>
                    <div onClick={() => setShowList(5)}  className="cursor-pointer">
                        <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.orderedListCount ? requestList?.orderedListCount.toString() : "0"} label={"Ordered"} bgColour="bg-request-status-ordered"/>
                    </div>
                    <div onClick={() => setShowList(6)}  className="cursor-pointer">
                        <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.purchasedListCount ? requestList?.purchasedListCount.toString() : "0"} label={"Purchased"} bgColour="bg-request-status-purchased"/>  
                    </div>
                    <div onClick={() => setShowList(7)}  className="cursor-pointer">
                        <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.deliveredListCount ? requestList?.deliveredListCount.toString() : "0"} label={"Delivered"} bgColour="bg-request-status-delivered"/>                                        
                    </div>
                    <div onClick={() => setShowList(8)}  className="cursor-pointer">
                        <RequestStatCard  totalRequest={100} numberOfRequest={requestList?.declinedListCount ? requestList?.declinedListCount.toString() : "0"} label={"Declined"} bgColour="bg-request-status-declined"/>
                    </div>
                </div>

                <div className="mt-4 grid grid-cols-12 gap-4 md:mt-6 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                    { listToShow() }
                </div>

            </MainLayout>        
        </>
    )
}

export default ArchivedListPage;